module.exports = __webpack_public_path__ + "static/media/phoneCircle3.a26cdeb4.png";